import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { Action } from "../Actions/Action";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownMenuItemWithDetail extends DropDownMenuItem {
    private _subTextElement: HTMLElement;
    private _subTextColor: string = "";
    private _addTextElement: HTMLElement;
    private _addTextColor: string = "";
    private _detail: HTMLElement;
    private _expandButton: HTMLElement;

    private _expandString: string;
    private _colapseString: string;

    public get isExpanded(): boolean {
        return this.classList.contains("expanded");
    }

    public set isExpanded(val: boolean) {
        this.classList.toggle("expanded", val);
    }

    public toggleExpand(): void {
        if (this.isExpanded) {
            this.isExpanded = false;
            this._expandButton.textContent = this._expandString;
        } else {
            this.isExpanded = true;
            this._expandButton.textContent = this._colapseString;
        }
        this.parent.recalculatePosition();
    }

    public get isEnabledExpand(): boolean {
        return !this.classList.contains("disabled-expand");
    }

    public set isEnabledExpand(val: boolean) {
        this.classList.toggle("disabled-expand", !val);
    }

    public setSubtext(value: string): void {
        this._subTextElement.innerText = value;
    }

    public setSubtextColor(color: string): void {
        this.setSubtextNoColor();
        this._subTextColor = color;
        this._subTextElement.classList.add(color);
    }

    public setSubtextNoColor(): void {
        if (this._subTextColor != "") {
            this._subTextElement.classList.remove(this._subTextColor);
            this._subTextColor = "";
        }
    }

    public setAddtext(value: string): void {
        if (value != "")
            this._addTextElement.classList.remove("hidden");
        else
            this._addTextElement.classList.add("hidden");
        this._addTextElement.innerText = value;
    }

    public setAddtextColor(color: string): void {
        this.setAddtextNoColor();
        this._addTextColor = color;
        this._addTextElement.classList.add(color);
    }

    public setAddtextNoColor(): void {
        if (this._addTextColor != "") {
            this._addTextElement.classList.remove(this._addTextColor);
            this._addTextColor = "";
        }
    }

    public setDetail(content: HTMLElement): void {
        this._detail.appendChild(content);
    }

    public setExpandIcon(): void {
        this._expandButton.classList.add("icon");
    }

    public setExpandText(): void {
        this._expandButton.classList.remove("icon");
    }

    public setOkIcon(): void {
        this._expandButton.classList.add("ok");
    }

    public setWarningIcon(): void {
        this._expandButton.classList.add("warning");
    }

    public static createDropDownMenuItemWithDetail(icon: string, caption: string = "", subtext: string = "", addtext: string = "", detail: HTMLElement = null, enabled: boolean = false, priority: number = 15): DropDownMenuItemWithDetail {
        const element = new DropDownMenuItemWithDetail();
        if (!detail)
            element._expandButton.style.visibility = "hidden";
        const action = new Action();

        element.setCaption(caption);
        element.setSubtext(subtext);
        element.setAddtext(addtext);

        element.action = action;
        action.enabled = enabled;

        if (icon != "")
            element.icon = icon;
        element.priority = priority;

        if (detail)
            element._detail.appendChild(detail);

        return element;
    }

    protected override _createElement(): void {
        super._createElement();

        this.classList.add("DropDownMenuItem", "item-with-detail");

        this._subTextElement = document.createElement("div");
        this._subTextElement.classList.add("sub-text");

        this._textElement.appendChild(this._subTextElement);

        this._createExpandButton();

        this._addTextElement = document.createElement("div");
        this._addTextElement.classList.add("add-text", "hidden");

        this.appendChild(this._addTextElement);

        this._detail = document.createElement("div");
        this._detail.classList.add("detail");

        this.appendChild(this._detail);
    }

    protected _createExpandButton(): void {
        this._expandButton = document.createElement("div");
        this._expandButton.classList.add("expand-btn");

        Localization.getTextPromise("GUI-348247").then((value) => {
            this._expandString = value;
            this._expandButton.textContent = this._expandString;
        });
        Localization.getTextPromise("GUI-311700").then((value) => {
            this._colapseString = value;
        });

        this.appendChild(this._expandButton);
    }

    protected override _setListener(): void {
        this.addEventListener("click", async (e: MouseEvent) => {
            if (e.button === 0 && this.isEnabledExpand) {
                e.stopImmediatePropagation();

                this.toggleExpand();
            }
        });
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuItemWithDetail", DropDownMenuItemWithDetail);
